/*global TTApplicationEnum, GetAppInfo, _moovilaSecurity */
import React, { Component } from 'react';
import { connect }          from 'react-redux';
import { withRouter }       from 'react-router-dom';
import axios from "axios";

import LicenseAssignment from '../../components/Admin/LicenseAssignment';

import {
  getUserLicenseList,
  getEnterpriseLicenseList,
  getLicenseList,
  showMessageBox,
  updateLicenseAssignment,
  updateUserLicenseAssignment,
  deleteLicenseAssignment,
  deleteUserLicenseAssignment,
  setQuestion,
} from '../../actions';

class LicenseAssignmentContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      your: 'mom',
    }
  }

  componentWillMount() {
    this.props.getLicenseList();
    if (this.props.type === 'enterprise') {
      this.props.getEnterpriseLicenseList(this.props.enterpriseGUID);
    } else if (this.props.type === 'user') {
      if (!this.props.primaryGUID) {
        console.error('[LicenseAssignmentContainer] primaryGUID prop required in user type');
        return;
      }
      this.props.getUserLicenseList(this.props.primaryGUID);
    }
  }

  render() {
    return (
      <LicenseAssignment
        location={this.props.location}
        type={this.props.type}
        enterpriseGUID={this.props.enterpriseGUID}
        primaryGUID={this.props.primaryGUID}
        secondaryGUID={this.props.secondaryGUID}
        licenseID={this.props.licenseID} // 
        assignments={this.props.assignments} // when the license was assigned
        licenses={this.props.licenses} // licenses
        enterprises={this.props.enterpriseMaintenance.list} // enterprise name
        users={this.props.enterpriseMaintenance.users}
        context={this.props.context}
        method={this.props.method}
        submethod={this.props.submethod}
        showMessageBox={this.props.showMessageBox}
        updateLicenseAssignment={this.props.updateLicenseAssignment}
        deleteLicenseAssignment={this.props.deleteLicenseAssignment}
        updateUserLicenseAssignment={this.props.updateUserLicenseAssignment}
        deleteUserLicenseAssignment={this.props.deleteUserLicenseAssignment}
        setQuestion={this.props.setQuestion}
        history={this.props.history}
      />
    );
  }
}

export default withRouter(connect(s => s, {
  getUserLicenseList,
  getEnterpriseLicenseList,
  getLicenseList,
  showMessageBox,
  updateLicenseAssignment,
  updateUserLicenseAssignment,
  deleteLicenseAssignment,
  deleteUserLicenseAssignment,
  setQuestion,
})(LicenseAssignmentContainer));



// WEBPACK FOOTER //
// ./src/containers/Admin/LicenseAssignment.js